import { InvalidParam, ParamSanitizer, saneNumber, saneOption, saneString } from 'logard';
import moment, { Moment } from 'moment';
import { ROUTE_DATE_FORMAT, ROUTE_DATE_TIME_FORMAT } from '@/planner/constants/general';
import { EnumType, EnumValue, enumValues } from './typescript';

export function saneNumericId<T>(input: string): T {
  return saneNumber(input) as T;
}

export function saneDate(input: string): Moment {
  const output = moment(input, ROUTE_DATE_FORMAT);
  if (!output.isValid()) throw new InvalidParam();
  return output;
}

export function saneDateTime(input: string): Moment {
  const output = moment(input, ROUTE_DATE_TIME_FORMAT);
  if (!output.isValid()) throw new InvalidParam();
  return output;
}

export function saneEnum<T extends EnumValue>(type: EnumType<T | string>): ParamSanitizer<T> {
  const options = enumValues(type);
  const base: any = typeof options[0] === 'number' ? saneNumber : saneString;
  return saneOption(options, base);
}